var map = {
	"./PXL_20250116_110747252.jpg": 5382,
	"./Screenshot_20250706-103109.png": 9718,
	"./c.jpg": 5761,
	"./f.jpg": 4864,
	"./ff.png": 408,
	"./fg.png": 8273,
	"./h.jpg": 782,
	"./k.jpg": 9449,
	"./l.jpg": 3706,
	"./o.jpg": 7845,
	"./t.jpg": 4018
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5041;